export const environment = {
  production: true,
  apiUrl: 'https://menuload.com/api/',


  firebaseConfig: {
    apiKey: "AIzaSyAZmvg6VgxQnuzFYzgbxFv3phLjm-0EhiQ",
    authDomain: "menuload-93b7e.firebaseapp.com",
    databaseURL: "https://menuload-93b7e-default-rtdb.firebaseio.com",
    projectId: "menuload-93b7e",
    storageBucket: "menuload-93b7e.firebasestorage.app",
    messagingSenderId: "965595317490",
    appId: "1:965595317490:web:f05687a60c2261b2297c6b",
    measurementId: "G-926SND4B4E"
  }

};
